"use client";
import React, { useState } from "react";
import "./styles.css";

export default function Switch({
  checked = false,
  onChange = () => {},
  disabled = false,
  label,
}) {
  const [state, setState] = useState(checked);

  const toggle = () => {
    if (disabled) return;
    const next = !state;
    setState(next);
    onChange(next);
  };

  return (
    <div className="switch-wrapper">
      <button
        className={`switch ${state ? "switch-on" : ""} ${disabled ? "switch-disabled" : ""}`}
        onClick={toggle}
        disabled={disabled}
      >
        <span className="switch-knob" />
      </button>

      {label && <span className="switch-label">{label}</span>}
    </div>
  );
}
